import { useQuery } from "@tanstack/react-query";
import { Assistant } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const widgetSummaryAvailabilityQueryKey = (widgetType) => [
  "assistant",
  "widget-summary",
  widgetType,
  "availability"
];
const fetchAvailability = (widgetType) => Assistant.widgetSummaryAvailability(encodeURIComponent(widgetType)).then((response) => {
  var _a;
  return {
    available: response.available,
    message: (_a = response.message) != null ? _a : void 0
  };
});
const useWidgetSummaryAvailability = (widgetType) => {
  const { data, isLoading } = useQuery({
    queryKey: widgetSummaryAvailabilityQueryKey(widgetType),
    queryFn: () => defaultOnError(
      fetchAvailability(widgetType),
      "Checking whether widget summaries are available failed",
      "Could not check widget summary availability"
    )
  });
  return { data: data != null ? data : { available: false, message: void 0 }, isLoading };
};
export default useWidgetSummaryAvailability;
